
import { SAVE_IN_PROGRESS, SAVE_PROCESS_DONE } from "./fetchingDataActions";
import { fetchItemsWS } from '../webservices/fetchWS';
import { createItemWs, updateItemWs } from "../webservices/saveWS";
import { toast } from "react-toastify";
import _ from "lodash";
import { TenantCloudDTO } from "./DTOs/TenantCloudDTO";
import { TenantDTO } from "./DTOs/TenantDTO";


export const FETCHING_TENANT_CLOUDS_ACTION = 'FETCHING_TENANT_CLOUDS_ACTION';
export const FETCH_TENANT_CLOUDS_SUCCESS_ACTION = 'FETCH_TENANT_CLOUDS_SUCCESS_ACTION';
export const FETCH_TENANT_CLOUDS_ERROR_ACTION = 'FETCH_TENANT_CLOUDS_ERROR_ACTION';

export const fetchTenantCloudsAction = (tenant) => {
    const queryParams = {
        PK: `TENANTCLOUDS`,
        SK: `TENANTCLOUD%23`,
    };

    return (dispatch, getState) => {
        dispatch({ type: FETCHING_TENANT_CLOUDS_ACTION });
        fetchItemsWS('get-dynamodb', queryParams, getState)
            .then((result) => {
                let items = result.Items;
                items = items.filter((item) => item.status !== 'isDeleted');
                dispatch({ type: FETCH_TENANT_CLOUDS_SUCCESS_ACTION, payload: items });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: FETCH_TENANT_CLOUDS_ERROR_ACTION, err });
            });
    };
}

export const TENANT_CLOUD_ADD_ACTION = "TENANT_CLOUD_ADD_ACTION";
export const TENANT_CLOUD_EDIT_ACTION = "TENANT_CLOUD_EDIT_ACTION";

const updateTenantQuestionnaires = async (tenants, questionnaires, getState) => {
    const updatePromises = tenants.map(async (tenant) => {
        const existingQuestionnaires = tenant.baseQnaires || [];
        const questionnairesToAdd = questionnaires.filter(q =>
            !existingQuestionnaires.some(existing => existing.id === q.id)
        );

        if (questionnairesToAdd.length > 0) {
            const updatedTenant = {
                ...tenant,
                baseQnaires: [...existingQuestionnaires, ...questionnairesToAdd]
            };
            const saveObject = new TenantDTO(updatedTenant);
            return updateItemWs(saveObject, getState);
        }
        return Promise.resolve();
    });

    return Promise.all(updatePromises);
};

export const saveTenantCloudAction = (cloud, isNew) => {
    return async (dispatch, getState) => {
        const saveObject = new TenantCloudDTO(cloud);
        dispatch({ type: SAVE_IN_PROGRESS });

        try {
            // Update tenant questionnaires before saving cloud
            if (cloud.tenants && cloud.questionnaires) {
                await updateTenantQuestionnaires(cloud.tenants, cloud.questionnaires, getState);
            }

            if (isNew === true) {
                const result = await createItemWs(saveObject, getState);
                dispatch({ type: TENANT_CLOUD_ADD_ACTION, payload: result.data });
                dispatch({ type: SAVE_PROCESS_DONE });
                toast.success("Tenant Cloud Successfully Created");
            } else {
                const result = await updateItemWs(saveObject, getState);
                dispatch({ type: TENANT_CLOUD_EDIT_ACTION, payload: result.data });
                dispatch({ type: SAVE_PROCESS_DONE });
                toast.success("Tenant Cloud Successfully Updated");
            }
        } catch (err) {
            console.log(err);
            dispatch({ type: SAVE_PROCESS_DONE });
            toast.error(isNew ? "Failed to create new tenant cloud. Please try again" : "Failed to update the tenant cloud. Please try again");
        }
    }
}

export const TENANT_CLOUD_DELETE_ACTION = "TENANT_CLOUD_DELETE_ACTION";

export const deleteTenantCloudAction = (cloud) => {
    return (dispatch, getState) => {
        const saveObject = new TenantCloudDTO(cloud);
        saveObject.status = "isDeleted";
        dispatch({ type: SAVE_IN_PROGRESS });
        updateItemWs(saveObject, getState)
            .then((result) => {
                dispatch({ type: TENANT_CLOUD_DELETE_ACTION, payload: result.data });
                dispatch({ type: SAVE_PROCESS_DONE });
                toast.success("Tenant Cloud Successfully Deleted");
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: SAVE_PROCESS_DONE });
                toast.success("Failed to delete the tenant cloud. Please try again");
            });
    }
}